/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { Link, withRouter } from "react-router-dom";
import ActiveLanguage from "components/widgets/language/ActiveLanguage";
import LanguageSelectorMobile from "components/widgets/language/LanguageSelectorMobile";
import Profilebar from "./Profilebar";
import { Trans } from "react-i18next";

class MobileMenu extends Component {
  // unlisten = this.props.history.listen((location, action) => {
  //   if (location.pathname !== this.state.prevPath) {
  //     $(".mobilMenu").toggleClass("show");
  //     $(".menu-toggle").toggleClass("open");
  //     this.setState({ prevPath: location.pathname });
  //   }
  // });

  componentDidMount() {
    // this.menuToggle();
  }

  componentDidUpdate() {
    // this.menuToggle();
  }

  componentWillUnmount = () => {
    // this.unlisten();
  };

  menuToggle = () => {
    // const self = this;
    // let cnt = this.state.count;
    // $(".menu-toggle").click(function () {
    //   $(".mobilMenu").toggleClass("show");
    //   $(this).toggleClass("open");
    //   if (cnt % 2 === 0) {
    //     $("body").css("overflow", "visible");
    //   } else {
    //     $("body").css("overflow", "hidden");
    //   }
    //   self.setState({ count: cnt + 1 });
    // });
  };

  showMobileMenu = (i) => {
    if ($("#minus_mobilnav" + i).css("display") === "none") {
      var menuLength = $(".mobilMenu").find(".duyuru_box").length;
      for (var f = 1; f <= menuLength; f++) {
        /*
        $(".mobilMenu").find(".duyuru_box")[f].children[1].style.display = "none";
        $(".mobilMenu").find(".duyuru_box")[f].children[2].style.display = "block";
        $('#table_mobilnav'+f).hide(100);
        */
        $("#duyuru_baslik_" + f).css("color", "#ffffff");
        $("#minus_mobilnav" + f).hide();
        $("#plus_mobilnav" + f).show();
        $("#table_mobilnav" + f).hide(100);
      }
      $("#duyuru_baslik_" + i).css("color", "#2d96cd");
      $("#minus_mobilnav" + i).show();
      $("#plus_mobilnav" + i).hide();
      $("#table_mobilnav" + i).show(100);
    } else {
      $("#duyuru_baslik_" + i).css("color", "#ffffff");
      $("#minus_mobilnav" + i).hide();
      $("#plus_mobilnav" + i).show();
      $("#table_mobilnav" + i).hide(100);
    }
  };

  renderLink = (name, path, icon) => {
    if (!this.props.navigation?.find((n) => n.name === path)) return null;
    return (
      <li>
        <Link to={path}>
          <span className={icon}></span> <span>{name}</span>
        </Link>
      </li>
    );
  };

  render() {
    return (
      <div className="mobilMenu show" tabIndex="2">
        <nav>
          <div className="row">
            <div className="col-md-12">
              <Profilebar />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 bt-view">
              <div
                className="duyuru_box"
                onClick={() => this.showMobileMenu("1")}
              >
                <div className="duyuru_baslik" id="duyuru_baslik_1">
                  Profil
                </div>
                <div
                  className="minus"
                  id="minus_mobilnav1"
                  style={{ display: "none" }}
                >
                  <span className="icon-icon-table-dropdown"></span>
                </div>
                <div className="minus" id="plus_mobilnav1">
                  <span className="icon-icon-detail"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row" id="table_mobilnav1" style={{ display: "none" }}>
            <div className="col-md-12">
              <ul className="submenu">
                <li>
                  <Link to="/profile#general">
                    <span className="icon-icon-menu-personal"></span>
                    <Trans desc="Genel Bilgiler">10059</Trans>
                  </Link>
                </li>
                <li>
                  <a href="/profile#contact">
                    <span className="icon-icon-menu-contact"></span>
                    <Trans desc="İletişim Bilgileri">10060</Trans>
                  </a>
                </li>
                <li>
                  <a href="/profile#other">
                    <span className="icon-icon-menu-other"></span>
                    <Trans desc="Diğer Bilgiler">10061</Trans>
                  </a>
                </li>
                <li>
                  <a href="/profile#company">
                    <span className="icon-icon-menu-personal"></span>
                    {/* <Trans desc="Bayi">10565</Trans> */}
                    {this.props.generalProfile.companyName}
                  </a>
                </li>
                {/* <li>
                  <a href="#">
                    <span className="icon-icon-menu-settings"></span> Ayarlar
                  </a>
                </li> */}
                {/* <li>
                  <a href="#">
                    <span className="icon-icon-menu-password"></span> Şifre
                    Değiştirme
                  </a>
                </li> */}
                <li className="cikisButonu">
                  <Link to="/logout">
                    <span className="icon-icon-menu-logout"></span>{" "}
                    <Trans desc="Çıkış">10062</Trans>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 bt-view">
              <div
                className="duyuru_box"
                onClick={() => this.showMobileMenu("2")}
              >
                <div className="duyuru_baslik" id="duyuru_baslik_2">
                  <Trans desc="Şirket Bilgileri">10024</Trans>
                </div>
                <div
                  className="minus"
                  id="minus_mobilnav2"
                  style={{ display: "none" }}
                >
                  <span className="icon-icon-table-dropdown"></span>
                </div>
                <div className="minus" id="plus_mobilnav2">
                  <span className="icon-icon-detail"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row" id="table_mobilnav2" style={{ display: "none" }}>
            <div className="col-md-12">
              <ul className="submenu">
                {this.renderLink(
                  <Trans desc="Bayi Bilgileri">10031</Trans>,
                  "/dealer-info",
                  "icon-icon-menu-distrubuter"
                )}
                {this.renderLink(
                  <Trans desc="Organizasyon Şeması">10030</Trans>,
                  "/organisation",
                  "icon-icon-menu-organisation"
                )}
                {this.renderLink(
                  <Trans desc="Ekibim">10028</Trans>,
                  "/my-team",
                  "icon-icon-menu-team"
                )}
                {this.renderLink(
                  <Trans desc="Organizsayon Değişimleri">10029</Trans>,
                  "/org-activities",
                  "icon-icon-menu-organisation-chart"
                )}
                {this.renderLink(
                  <Trans desc="Rehber">10032</Trans>,
                  "/guide",
                  "icon-icon-menu-general"
                )}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 bt-view">
              <div
                className="duyuru_box"
                onClick={() => this.showMobileMenu("3")}
              >
                <div className="duyuru_baslik" id="duyuru_baslik_3">
                  <Trans desc="Eğitim ve Gelişim">10025</Trans>
                </div>
                <div
                  className="minus"
                  id="minus_mobilnav3"
                  style={{ display: "none" }}
                >
                  <span className="icon-icon-table-dropdown"></span>
                </div>
                <div className="minus" id="plus_mobilnav3">
                  <span className="icon-icon-detail"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row" id="table_mobilnav3" style={{ display: "none" }}>
            <div className="col-md-12">
              <ul className="submenu">
                {this.renderLink(
                  <Trans desc="Eğitim Takvimi">10034</Trans>,
                  "/calendar",
                  "icon-icon-menu-calendar"
                )}
                {this.renderLink(
                  <Trans desc="Gelişim Planı">10035</Trans>,
                  "/evolution-plan",
                  "icon-icon-menu-improvement"
                )}
                {this.renderLink(
                  <Trans desc="Çalışan Eğitim Yönetimi">10707</Trans>,
                  "/employee-training-management",
                  "icon-icon-menu-improvement"
                )}
                {this.renderLink(
                  <Trans desc="Talep Edilen Eğitimlerim">10569</Trans>,
                  "/training-requests",
                  "icon-icon-table-approve"
                )}
                {this.renderLink(
                  <Trans desc="Yeterlilik">10037</Trans>,
                  "/competency",
                  "icon-icon-menu-qualification"
                )}
                {this.renderLink(
                  <Trans desc="Bayi Eğitim Potansiyeli">10406</Trans>,
                  "/potential-trainings",
                  "icon-potansiyel-egitimler"
                )}
                {this.renderLink(
                  <Trans>nav_ford-role-and-authrorize</Trans>,
                  "/employee-roles",
                  "icon-ford-role"
                )}
                {this.renderLink(
                  <Trans desc="Eğitime Kayıtlı Çalışanlar">10527</Trans>,
                  "/employee-training-registrations",
                  "icon-potansiyel-egitimler"
                )}
                {this.renderLink(
                  <Trans desc="Aldığım Eğitimler">10038</Trans>,
                  "/completed-trainings",
                  "icon-icon-menu-achived"
                )}
                {this.renderLink(
                  <Trans desc="Bilgilendirme Videoları">10058</Trans>,
                  "/informational-videos",
                  "icon-icon-menu-achived"
                )}
                {/* {this.renderLink(
                  <Trans desc="Eğitim Kataloğu">trainingcatalog</Trans>,
                  "/training-catalog",
                  "icon-icon-menu-achived"
                )} */}
                {this.renderLink(
                  <Trans desc="Faturalar">10033</Trans>,
                  "/invoices",
                  "icon-icon-menu-bill"
                )}
                {this.renderLink(
                  <Trans desc="Eğitim Anketi/Testi">10042</Trans>,
                  "/survey",
                  "icon-icon-menu-survey"
                )}
                {this.renderLink(
                  <Trans desc="Aday Havuzu">10598</Trans>,
                  "/applicant-pool",
                  "icon-ford-role"
                )}
                {this.renderLink(
                  <Trans desc="Çalışan 360">employee360_title</Trans>,
                  "/employee-360",
                  "icon-potansiyel-egitimler"
                )}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 bt-view">
              <div
                className="duyuru_box"
                onClick={() => this.showMobileMenu("4")}
              >
                <div className="duyuru_baslik" id="duyuru_baslik_4">
                  <Trans desc="Kurumsal">10026</Trans>
                </div>
                <div
                  className="minus"
                  id="minus_mobilnav4"
                  style={{ display: "none" }}
                >
                  <span className="icon-icon-table-dropdown"></span>
                </div>
                <div className="minus" id="plus_mobilnav4">
                  <span className="icon-icon-detail"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row" id="table_mobilnav4" style={{ display: "none" }}>
            <div className="col-md-12">
              <ul className="submenu">
                {this.renderLink(
                  <Trans desc="Vizyon ve Misyon">10039</Trans>,
                  "/vision",
                  "icon-icon-menu-vision"
                )}
                {this.renderLink(
                  <Trans desc="Ford Organizasyon">10040</Trans>,
                  "/ford-organization",
                  "icon-icon-menu-organisation"
                )}
                {this.renderLink(
                  <Trans desc="Sıkça Sorulan Sorular">10041</Trans>,
                  "/faq",
                  "icon-icon-menu-faq"
                )}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 bt-view">
              <div
                className="duyuru_box"
                onClick={() => this.showMobileMenu("5")}
              >
                <div className="duyuru_baslik" id="duyuru_baslik_5">
                  Dil Seçimi
                </div>
                <ActiveLanguage />
                <div
                  className="minus"
                  id="minus_mobilnav5"
                  style={{ display: "none" }}
                >
                  <span className="icon-icon-table-dropdown"></span>
                </div>
                <div className="minus" id="plus_mobilnav5">
                  <span className="icon-icon-detail"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row" id="table_mobilnav5" style={{ display: "none" }}>
            <LanguageSelectorMobile />
          </div>
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    navigation: state.profile.general.navigations,
    generalProfile: state.profile.general,
  };
};

export default connect(mapStateToProps, null)(withRouter(MobileMenu));
